<script setup>
defineProps({
  label: { type: String, required: true },
  value: { type: String, required: true },
});
</script>

<template>
  <div class="stat">
    <p>{{ label }}</p>
    <strong>{{ value }}</strong>
  </div>
</template>
